"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoIcon = function (_React$Component) {
    _inherits(InfoIcon, _React$Component);

    function InfoIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, InfoIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfoIcon.__proto__ || Object.getPrototypeOf(InfoIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (light) {
            return _react2.default.createElement(
                "svg",
                { id: "Info-outlined", xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20" },
                _react2.default.createElement(
                    "g",
                    { id: "Info-outlined-2", "data-name": "Info-outlined", transform: "translate(22 22) rotate(180)" },
                    _react2.default.createElement("path", { id: "Icon_color", "data-name": "Icon color", d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20ZM10,2a8,8,0,1,0,8,8A8.009,8.009,0,0,0,10,2Zm.5,12h-1a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1A.5.5,0,0,1,10.5,14ZM9.468,10a.25.25,0,0,1-.248-.22l-.4-3.22a.5.5,0,0,1,.5-.56H10.68a.5.5,0,0,1,.5.56l-.4,3.22a.25.25,0,0,1-.248.22H9.468Z", transform: "translate(2 2)", fill: light ? "#fff" : "#000" })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(InfoIcon, [{
        key: "render",
        value: function render() {
            var light = this.props.light;
            return this.getIcon(light);
        }
    }]);

    return InfoIcon;
}(_react2.default.Component);

exports.default = InfoIcon;